angular.module('vrm.components')
    .directive('vrmInstallationsTable', vrmInstallationsTable);

/* @ngInject */
function vrmInstallationsTable(InstallationsService, vrmConfig) {
    function link($scope) {
        // Mobile view detection
        $scope.mobileView = window.innerWidth < 750;
        angular.element(window).on('resize', _.debounce(function () {
            $scope.mobileView = window.innerWidth < 750;
            $scope.$digest();
        }, 250));

        $scope.mobileDetailThreshold = vrmConfig.mobileInstallationOverviewDetailThreshold || 100;
    }

    return {
        scope: {
            installations: "=",
            overviewSearch: "=",
            enabledColumns: "=",
            detailMode: "=",
            totalEnabled: "=",
            installationCount: "=",
            onRunningSinceLoaded: "="
        },
        restrict: 'E',
        template: require('@/angular/modules/vrm-components/installations-table/installations-table.template.html'),
        transclude: true,
        link,
    };
}
